import React from 'react';
import styled from 'styled-components';


const FeedBackPopup = ( { text, actionHandler, type }: any ) => {

    return (

        <FeedBackPopupWrapper>
            <div className="feedback-model">

                <div className={ `close-panel ${ type } ` }>
                    <span onClick = { actionHandler } >X</span>
                </div>
                <div className="feedback-body">
                    <h3>{ type } : { text }</h3>
                </div>

            </div>
        </FeedBackPopupWrapper>

    )

}

const FeedBackPopupWrapper = styled.div`

    .feedback-model {
        position: fixed;
        top: 20%;
        left: 50%;
        transform: translate( -50%, -50% );
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 400px;
        height: 200px;
        background: white;
        z-index: 2;
        border: 1px solid black;
        display: flex;
        flex-direction: column;
        justify-content: start;
    }
    .close-panel {
        width: 100%;
        height: 14%;
        padding: 10px;
        font-weight: 20px;
        display: flex;
        justify-content: right;
    }
    .error {
        background: red;
    }
    .success {
        background: green;
    }
    .feedback-body {
        height: 80%;
        font-size: 20px;
        letter-spacing: 2px;
        padding: 20px;
    }

`;

export default FeedBackPopup;
